import { UserStatus } from "../../models/enums/user-status.enum";
import { User } from "../../models/interfaces/user.interface";

const TENANT_ID = 'tenant-uuid';
const TENANT_NAME = 'Tenant Teste';

export const userMock: User[] = [
  {
    id: 'user1',
    tenantId: TENANT_ID,
    tenantName: TENANT_NAME,
    email: 'user1@facens.br',
    name: 'Usuário 1',
    status: UserStatus.ACTIVE,
    roles: ['app:*'],
    isAdmin: false,
    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: true,
  },
  {
    id: 'user2',
    tenantId: TENANT_ID,
    tenantName: TENANT_NAME,
    email: 'user2@facens.br',
    name: 'Usuário 2',
    status: UserStatus.ACTIVE,
    roles: ['app:*'],
    isAdmin: false,
    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: true,
  },
  {
    id: 'user3',
    tenantId: TENANT_ID,
    tenantName: TENANT_NAME,
    email: 'user3@facens.br',
    name: 'Usuário 3',
    status: UserStatus.ACTIVE,
    roles: ['app:*'],
    isAdmin: false,
    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: true,
  },
  {
    id: '1c41afca-e637-4d9f-8cd1-2b3f3302f80d',
    tenantId: TENANT_ID,
    tenantName: TENANT_NAME,
    email: 'user@unico.com',
    name: 'Aluno Teste',
    status: UserStatus.ACTIVE,
    roles: ['app:*'],
    isAdmin: false,
    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: true,
  }
];
